import React from "react";
import { Card } from "styles/pages/web-checkout.styles";
import {
  DataSection,
  SectionTitle,
  DataGrid,
  DataItem,
  Label,
  Value,
  CardHeading,
  CardSubheading,
  UpdateProfileCTA,
  SubmitProfileCTA,
  ProfileWrapper
} from "./student-data-confirmation.styles";
import { IStudentDataConfirmation } from "./student-confirmation.types";

export const StudentDataConfirmation: React.FC<IStudentDataConfirmation> = ({
  studentData,
  parentData,
  onUpdate,
  onConfirmAll,
  isLoading
}) => {
  return (
    <Card>
      <CardHeading>
        Pastiin semua datanya udah benar sebelum lanjut ya
      </CardHeading>
      <CardSubheading>
        Kalo ada yang perlu diubah bisa klik pencet ubah data
      </CardSubheading>

      <DataSection>
        <SectionTitle>Data Murid</SectionTitle>
        <DataGrid>
          <div>
            <DataItem>
              <Label>Nomor HP</Label>
              <Value>+62{studentData.phone}</Value>
            </DataItem>
            <DataItem>
              <Label>Email</Label>
              <Value>{studentData.email}</Value>
            </DataItem>
            <DataItem>
              <Label>Nama</Label>
              <Value>{studentData.name}</Value>
            </DataItem>
            <DataItem>
              <Label>Tempat tinggal</Label>
              <Value>{studentData.location}</Value>
            </DataItem>
          </div>

          <div>
            <DataItem>
              <Label>Nama sekolah</Label>
              <Value>{studentData.school}</Value>
            </DataItem>
            <DataItem>
              <Label>Kelas</Label>
              <Value>{studentData.grade}</Value>
            </DataItem>
            <DataItem>
              <Label>Kurikulum</Label>
              <Value>{studentData.curriculum}</Value>
            </DataItem>
          </div>
        </DataGrid>
      </DataSection>

      <DataSection>
        <SectionTitle>Data Orang tua</SectionTitle>
        <DataGrid>
          <DataItem>
            <Label>Nomor HP orangtua</Label>
            <Value>+62{parentData.phone}</Value>
          </DataItem>
          <DataItem>
            <Label>Nama orangtua</Label>
            <Value>{parentData.name}</Value>
          </DataItem>
        </DataGrid>
      </DataSection>

      <ProfileWrapper>
        <UpdateProfileCTA
          isLoading={false}
          disabled={isLoading}
          type="submit"
          variant="secondary"
          onClick={() => onUpdate()}
          data-testid="update-profile-button"
        >
          Ubah data
        </UpdateProfileCTA>
        <SubmitProfileCTA
          isLoading={isLoading}
          disabled={false}
          type="submit"
          variant="primary"
          onClick={() =>
            onConfirmAll({ student: studentData, parent: parentData })
          }
          data-testid="complete-profile-button"
        >
          Benar semua
        </SubmitProfileCTA>
      </ProfileWrapper>
    </Card>
  );
};
